<h1 class="sr-only">Trang chủ DoctorCity Member</h1>

@if (!userData) {
  <div class="home-loading">
    <div class="home-loading-spinner"></div>
    <span>Đang tải dữ liệu…</span>
  </div>
} @else {
  <!-- Welcome banner -->
  <div class="home-welcome">
    <div class="home-welcome__text">
      <h2 class="home-welcome__title">Chào mừng trở lại 👋</h2>
      <p class="home-welcome__sub">{{ userData.email }}</p>
    </div>
    <div class="home-welcome__diamonds">
      <span class="diamonds-badge">🏵️ {{ userData.diamonds }}</span>
    </div>
  </div>

  <!-- KPI stats -->
  @if (member) {
    <div class="kpi-row" aria-label="Thống kê nhanh">
      <div class="kpi-card">
        <div class="kpi-card__value">{{ stats.plans !== null ? stats.plans : '—' }}</div>
        <div class="kpi-card__label">Hồ sơ</div>
      </div>
      <div class="kpi-card">
        <div class="kpi-card__value">{{ stats.members !== null ? stats.members : '—' }}</div>
        <div class="kpi-card__label">Thành viên đã giới thiệu</div>
      </div>
      <div class="kpi-card">
        <div class="kpi-card__value">{{ userData.diamonds }}</div>
        <div class="kpi-card__label">Điểm 🏵️</div>
      </div>
    </div>
  }

  <!-- Quick actions -->
  @if (member) {
    <section class="home-section" aria-label="Truy cập nhanh">
      <h2 class="home-section__title">Truy cập nhanh</h2>
      <div class="quick-grid">
        <button class="quick-card" (click)="navigateToQlyHoSo()">
          <span class="quick-card__icon">📋</span>
          <span class="quick-card__label">Quản lý<br>khách hàng</span>
        </button>
        <button class="quick-card" (click)="navigateToQlyThanhVien()">
          <span class="quick-card__icon">👥</span>
          <span class="quick-card__label">Quản lý<br>thành viên</span>
        </button>
        <button class="quick-card" (click)="goEventInteractionReport()">
          <span class="quick-card__icon">📊</span>
          <span class="quick-card__label">Báo cáo<br>sự kiện</span>
        </button>
      </div>
    </section>
  } @else {
    <!-- Not yet a member -->
    <div class="home-empty">
      <div class="home-empty__logo">
        <img src="assets/backgroundH.png" alt="DoctorCity" style="max-width:220px;max-height:220px;object-fit:contain" />
      </div>
      <p class="home-empty__msg">
        Tài khoản chưa đủ điều kiện sử dụng tính năng thành viên.<br>
        Liên hệ quản trị viên để được cấp quyền.
      </p>
    </div>
  }
}
